/**
 * @name LevelService
 * @description Servicio para gestionar los niveles en Administración
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta los niveles de una empresa
 * Cualquier usuario con acceso a Talentry puede consultar este servicio
 * @param {any} request filter { level, estatus, columns }
 * @return {any} promise
 */
const get = (request) => {
  let level = request.filter.nivel === undefined ? '' : `&descripcion=${request.filter.nivel}`;
  let status = request.filter.estatus === undefined ? '' : `&estatus=${request.filter.estatus}`;
  let columns = request.filter.columnas === undefined ? '' : `&columnas=${request.filter.columnas}`;

  let URL = `${BASE_URL}/Nivel?paginado=0,0${level}${status}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta el nivel de una empresa
 * @param {any} request IdNivel
 * @return {any} promise
 */
const getById = (request) => {
  let URL = `${BASE_URL}/Nivel/${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Añade un nivel
 * @param {object} level
 * @return {any} promise
 */
const post = (level) => {
  let URL = `${BASE_URL}/Nivel`;

  return axios.post(URL, level).then(({ data }) => {
    return data;
  });
};

/**
 * Actualiza un nivel
 * @param {object} level
 * @return {any} promise
 */
const put = (level) => {
  let URL = `${BASE_URL}/Nivel/${level.IdNivel}`;

  return axios.put(URL, level).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta el total de registros
 * @return {any} promise
 */
const size = () => {
  let URL = `${BASE_URL}/Nivel/TotalRegistros`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

export const LevelService = {
  get,
  getById,
  post,
  put,
  size
};